import AHMIS, { API_URL } from "../api/api";
import AddAlertMessage from "../components/alert/Alert";
import { ERROR, SOMETHING_WENT_WRONG } from "../utils/constants";
import { SAVE_USER_INFO } from "../utils/constants/redux";

export const getUserInfo = () => async (dispatch) => {
  try {
    let response = await AHMIS.get(API_URL.user);
    let jsondata = response.data;
    if (jsondata) {
      dispatch({ type: SAVE_USER_INFO, payload: jsondata, });
    }
  } catch (error) {
    AddAlertMessage({
      type: ERROR,
      message: SOMETHING_WENT_WRONG,
    });
  }
};
